import { useState } from 'react';
import { TrendingUp, InfoIcon } from 'lucide-react';

interface EarlyVotingBonusTooltipProps {
  earlyBonus: number;
}

export default function EarlyVotingBonusTooltip({ earlyBonus }: EarlyVotingBonusTooltipProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  return (
    <div className="relative inline-flex items-center">
      <TrendingUp className="h-4 w-4 mr-2 text-yellow-600" />
      <span>
        Early voting bonus: <span className="font-semibold">{earlyBonus}%</span> of activity score
      </span>
      <button
        className="ml-1.5 text-yellow-600 hover:text-yellow-800 transition-colors"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={(e) => {
          e.preventDefault();
          setShowTooltip(!showTooltip);
        }}
      >
        <InfoIcon className="h-3.5 w-3.5" />
      </button>
      
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-2 w-64 p-3 bg-white rounded-lg shadow-lg border border-yellow-200 text-xs z-10">
          <div className="font-semibold mb-1 text-gray-800">Early Voting Bonus Tiers:</div>
          <ul className="space-y-1 text-gray-700">
            <li className="flex justify-between">
              <span>First 10% of duration:</span>
              <span className="font-medium">100% of points</span>
            </li>
            <li className="flex justify-between">
              <span>10-30% of duration:</span>
              <span className="font-medium">75% of points</span>
            </li>
            <li className="flex justify-between">
              <span>30-60% of duration:</span>
              <span className="font-medium">50% of points</span>
            </li>
            <li className="flex justify-between">
              <span>60-90% of duration:</span>
              <span className="font-medium">25% of points</span>
            </li>
            <li className="flex justify-between">
              <span>Last 10% of duration:</span>
              <span className="font-medium">5% of points</span>
            </li>
          </ul>
          <div className="mt-2 text-gray-600">Vote early to maximize your activity score!</div>
        </div>
      )}
    </div>
  );
}